module.exports = __webpack_public_path__ + "static/media/unsubscribe_success.1cf94040.svg";